<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>付款单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <div class="left">
            </div>
            <div class="right">
                <div v-if="checkActionPerm('do_export')" class="swb-btn swb-btn-small swb-btn-primary" @click="taskExport()">执行导出任务</div>
                <div v-if="checkActionPerm('view_export_file')" class="swb-btn swb-btn-small swb-btn-primary" @click="viewTaskExport()">查看结果文件</div>
            </div>
        </div>

        <swb-result-table name="result_table" ref="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>

    </div>
</template>

<script>
import {$, Utils} from '../../app.base'
import {DomSizeWatcher, MsgBox, Routes, Vue} from '../../app.vues'
import {getDefaultPageSizes} from '../../app.conf'
import {checkUserActionPerm} from '../index'
import {showBankAccInfoDlg} from '../settle/showDlg'
import {openRecordReservedInfoDlg} from "./showDlg";
import {createTaskExportDlg, viewTaskExportListDlg} from '../devc/selectDlg'

import finacApi from '../../api/finac'
import comnApi from "../../api/comn";
import userApi from "../../api/user";

import SwbPayVoucherInfo from './PayVoucherInfo';
//
import SwbGoodsPurchContractList from '../contract/GoodsPurchContractList';
import SwbServcPurchContractList from '../contract/ServcPurchContractList';
import SwbIntegPurchContractList from '../contract/IntegPurchContractList';
import SwbShowGoodsOrder from '../order/ShowGoodsOrder';
import SwbServcOrderOperate from '../servcOrder/ServcOrderOperate';
import SwbQuerySortArea from '../query/QuerySortArea';
import SwbPayActRecList from './PayActRecList';

Vue.regist(SwbPayVoucherInfo);

Routes.add(SwbGoodsPurchContractList);

Routes.add(SwbServcPurchContractList);

Routes.add(SwbIntegPurchContractList);

Routes.add(SwbShowGoodsOrder);

Routes.add(SwbServcOrderOperate);

Vue.regist(SwbQuerySortArea);

Vue.regist(SwbPayActRecList);

export default {
    name: 'swb-pay-voucher-list',
    path: '/pay/voucher/list',
    avlActions: 'update_bankAccInfo|pay|view_detail|view_rec|delete|do_export|view_export_file|record_reservedPayNo',
    avlActionNames: '补充银行卡、付款、查看详情、查看操作记录、删除、执行导出任务、查看结果文件、补录凭证号',
    avlScopes: 'retailer',
    desc: '付款单列表',
    helpArticleCode: 'pay-voucher-list',
    data: function () {
        return {
            // 分页信息
            pageNumber: 1,
            totalCount: 0,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            //
            confKey: 'swb-pay-voucher-list',
            theTableHeight: 590,
            //
            needPager: true, //是否需要分页（默认：true）
            multiSelect: true, //是否多选（默认：false）
            multiPageSelect: true, //是否要多页/跨页选择（默认：false）
            rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
            rowNoShow: false, //是否显示行号（默认：true）
            rowNoFixed: false, //行号列是否固定（默认：false）
            //
            btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
            btnColTitle: '操作',//操作列标题（默认：'操作'）
            btnColWidth: 260,//操作列宽度（默认：100）
            btnColFixed: true, //操作列是否固定

            //排序、搜索
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            },
            exportFilter: {},
            //
            payVoucherList: [],
            srcVoucherTypeMap: getEnumMap("srcVoucherType", "value2text"),
            overallStateMap: getEnumMap("overallState", "value2text"),
            resultStateMap: getEnumMap("resultState", "value2text"),
            payWayMap: getEnumMap("payWay", "value2text"),
            payFormMap: getEnumMap("payForm", "value2text"),
            payMethodMap: getEnumMap("payMethod", "value2text"),
            scopeEntity: {},
            // 跳转信息
            no: null,
            srcVoucherType: null,
            srcVoucherId: null,
            srcVoucherInnerNo: null // 订单列表跳转付款单使用，区分服务订单还是商品订单
        }
    },
    created: function () {
        //保持pageSize的一致性
        this.pageSize = this.pageSizes.first();
        //
        let routeQuery = this.$getRouteQuery();
        let no = routeQuery.no || null;
        if (!Utils.isNoB(no)) {
            this.no = no;
        }
        let srcVoucherType = routeQuery.srcVoucherType || null;
        if (!Utils.isNoB(srcVoucherType)) {
            this.srcVoucherType = srcVoucherType;
        }
        let srcVoucherId = routeQuery.srcVoucherId || null;
        if (!Utils.isNoB(srcVoucherId)) {
            this.srcVoucherId = srcVoucherId;
        }
        let srcVoucherInnerNo = routeQuery.srcVoucherInnerNo || null;
        if (!Utils.isNoB(srcVoucherInnerNo)) {
            this.srcVoucherInnerNo = srcVoucherInnerNo;
        }
        //
        this.getCurrentUserInfo();
    },
    mounted() {
        let self = this;
        //注册domSizeWatcher
        let thisEl = $(this.$el);
        $(this.$el).addClass('overflow-hidden');
        //
        let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
        domSizeWatcher.setBaseEl(thisEl);
        domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
            //  根据新主元素的内容大小，调整表格高度
            self.theTableHeight = height;
        });
        //domSizeWatcher.setHrEls();
        domSizeWatcher.setVtEls(thisEl.find('.breadcrumb-layout, [name="query-sort-block"], [name="btns"]'));
        domSizeWatcher.start(500);
        //
        this.initResultTable();
    },
    destroyed() {
        //释放domSizeWatcher
        let domSizeWatcher = this.domSizeWatcher;
        if (domSizeWatcher != null) {
            domSizeWatcher.clear();
            this.domSizeWatcher = null;
        }
    },
    methods: {
        getCurrentUserInfo: function () {
            let self = this;
            userApi.getUserInfoByContext({}, function (result, jqXhr) {
                if (result.type == 'info') {
                    let data = result.data;
                    self.scopeEntity = data.scopeEntity;
                } else {
                    self.$message.warning(result.message);
                }
            });
        },
        onConfigReady() {
            let srcVoucherTypeList = getEnumList("srcVoucherType") || [];
            if (srcVoucherTypeList.length > 0) {
                let dataList = [];
                dataList.push({"value": null, "label": "-全部-"});
                srcVoucherTypeList.forEach(function (item) {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                });
                this.updateQueryModelField("srcVoucherType", dataList);
            }
            //
            let payWayList = getEnumList("payWay") || [];
            if (payWayList.length > 0) {
                let dataList = [];
                dataList.push({"value": null, "label": "-全部-"});
                payWayList.forEach(function (item) {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                });
                this.updateQueryModelField("payWay", dataList);
            }
            //
            let payResultList = getEnumList("resultState") || [];
            if (payResultList.length > 0) {
                let dataList = [];
                dataList.push({"value": null, "label": "-全部-"});
                dataList.push({"value": 0, "label": "待付款"});
                payResultList.forEach(function (item) {
                    if (item.value != 0) {
                        dataList.push({
                            value: item.value,
                            label: item.text
                        });
                    }
                });
                this.updateQueryModelField("payResult", dataList);
            }
            //
            let confirmStateList = [];
            confirmStateList.push({"value": null, "label": "-全部-"});
            confirmStateList.push({"value": true, "label": "已确认"});
            confirmStateList.push({"value": false, "label": "未确认"});
            this.updateQueryModelField("confirmState", confirmStateList);
            //
            let payFormList = getEnumList("payForm") || [];
            if (payFormList.length > 0) {
                let dataList = [];
                dataList.push({"value": null, "label": "-全部-"});
                payFormList.forEach(function (item) {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                });
                this.updateQueryModelField("payForm", dataList);
            }
            //
            let payMethodList = getEnumList("payMethod") || [];
            if (payMethodList.length > 0) {
                let dataList = [];
                dataList.push({"value": null, "label": "-全部-"});
                payMethodList.forEach(function (item) {
                    dataList.push({
                        value: item.value,
                        label: item.text
                    });
                });
                this.updateQueryModelField("payMethod", dataList);
            }
            // 跳转参数
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            if (!Utils.isNoB(this.no)) {
                let data = {value: this.no};
                let fieldInfo = {};
                fieldInfo['no'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            if (!Utils.isNoB(this.srcVoucherType)) {
                let data = {value: this.srcVoucherType};
                let fieldInfo = {};
                fieldInfo['srcVoucherType'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
            if (!Utils.isNoB(this.srcVoucherInnerNo)) {
                let data = {value: this.srcVoucherInnerNo};
                let fieldInfo = {};
                fieldInfo['srcVoucherInnerNo'] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        updateQueryModelField: function (itemCode, dataList = []) {
            if (itemCode != null) {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let data = {dataList: dataList};
                let fieldInfo = {};
                fieldInfo[itemCode] = data;
                query_model_ctrl.updateFields(fieldInfo);
            }
        },
        queryHandler(queryModel) {
            console.log('----------  查询、排序参数 ---------');
            //1、接收查询条件
            this.queryModel = queryModel;
            //缓存查询条件
            this.pageNumber = 1;
            console.log(queryModel);
            //
            this.getPayVoucherList();
        },
        // 检查资源具体操作权限（可选的是否为指定的岗位id）
        checkActionPerm: function (action, targetPostId) {
            return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
        },
        initResultTable() {
            let self = this;
            let query_model_ctrl = this.$refs['query_model_ctrl'];
            let resultTable = this.$refs['result_table'];
            //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
            resultTable.setQrySortRef(query_model_ctrl);
            //
            resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                'srcVoucherType': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.srcVoucherTypeMap[row.srcVoucherType] + '</span>';
                },
                'amount': function (row, colName, colValue, rowIndex, colConf) {
                    if (!Utils.isNoB(row.amount)) {
                        return '<span>' + parseFloat(row.amount).toFixed(2) + '</span>';
                    }
                },
                'overallState': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.overallStateMap[row.overallState] + '</span>';
                },
                'state': function (row, colName, colValue, rowIndex, colConf) {
                    let stateText = '';
                    if (row.applyState == 0) {
                        stateText = '未申请';
                    } else if (row.applyState == 1 && row.auditState == 0) {
                        stateText = '待审核';
                    } else if (row.applyState == 2 && row.auditState == 1) {
                        stateText = '审核通过';
                    } else if (row.applyState == 2 && row.auditState == -1) {
                        stateText = '审核未通过';
                    }
                    return '<span>' + stateText + '</span>';
                },
                'payResult': function (row, colName, colValue, rowIndex, colConf) {
                    if (row.payResult == 0) {
                        return '<span>待付款</span>';
                    } else {
                        return '<span>' + self.resultStateMap[row.payResult] + '</span>';
                    }
                },
                'payWay': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.payWayMap[row.payWay] + '</span>';
                },
                'payForm': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.payFormMap[row.payForm] + '</span>';
                },
                'payMethod': function (row, colName, colValue, rowIndex, colConf) {
                    return '<span>' + self.payMethodMap[row.payMethod] + '</span>';
                },
                'actions': function (row, colName, colValue, rowIndex) {
                    let btnList = [];
                    if (self.checkActionPerm('update_bankAccInfo') && !row.discarded && row.payResult != 1) {
                        btnList.push({
                            name: 'update_bankAccInfo',
                            text: '补充银行卡'
                        });
                    }
                    if (self.checkActionPerm('pay') && !row.discarded && row.auditState == 1 && row.payResult != 1) {
                        btnList.push({
                            name: 'pay',
                            text: '付款'
                        });
                    }
                    if (self.checkActionPerm('view_detail')) {
                        btnList.push({
                            name: 'view_detail',
                            text: '查看详情'
                        });
                    }
                    if (self.checkActionPerm('view_rec')) {
                        btnList.push({
                            name: 'view_rec',
                            text: '查看操作记录'
                        });
                    }
                    if (self.checkActionPerm('record_reservedPayNo') && row.payResult == 1 && (row.reservedPayNo == null || row.reservedPayNo == '')) {
                        btnList.push({
                            name: 'record_reservedPayNo',
                            text: '补录凭证号'
                        });
                    }
                    if (self.checkActionPerm('delete') && row.applyState == 0) {
                        btnList.push({
                            name: 'delete',
                            text: '删除'
                        });
                    }
                    return btnList;
                }
            }, /* 单元格按钮点击处理函数 */{
                //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                'srcVoucherInnerNo': function (row, colName, colValue, rowIndex, btnName) {
                },
                'actions': function (row, colName, colValue, rowIndex, btnName) {
                    if (btnName == 'update_bankAccInfo') {
                        // 补充银行卡
                        self.editBankAccInfo(row);
                    } else if (btnName == 'pay') {
                        // 付款
                        self.paymentOption(row, 'fuKuan');
                    } else if (btnName == 'view_detail') {
                        // 查看详情
                        self.paymentOption(row, 'chaKan');
                    } else if (btnName == 'view_rec') {
                        // 查看操作记录
                        self.viewPayActRecs(row.id);
                    } else if (btnName == 'record_reservedPayNo') {
                        // 补录凭证号
                        self.doRecordReservedPayNo(row);
                    } else if (btnName == 'delete') {
                        // 删除
                        self.doDelete(row.id);
                    }
                }
            });
        },
        renderTable(rows, pagination) {
            //
            let resultTable = this.$refs.result_table;
            //清除数据（如果已经渲染的数据与新的列不是一回事儿）
            //resultTable.clear();
            //同步使用新的自定义列信息
            //resultTable.initMeta(confColList);
            //设置新数据
            let tableData = {
                rows: rows,
                pagination: pagination
            };

            resultTable.render(tableData);
        },
        pageNoChangeHandler: function (pageNumber, pageSize) {
            console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
            //
            this.pageSize = pageSize;
            this.pageNumber = pageNumber;
            //
            this.getPayVoucherList();
        },
        getTableSelection() {
            let resultTable = this.$refs.result_table;
            return resultTable.getSelection();
        },
        // 查询付款单
        getPayVoucherList: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber
            };
            let queryModel = self.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            //
            let state = filterItems.state;
            if (!Utils.isNoB(state)) {
                if (state == 0) {
                    filterItems.applyState = 0;
                } else if (state == 1) {
                    filterItems.applyState = 1;
                    filterItems.auditState = 0;
                } else if (state == 2) {
                    filterItems.applyState = 2;
                    filterItems.auditState = 1;
                } else if (state == 3) {
                    filterItems.applyState = 2;
                    filterItems.auditState = -1;
                }
                filterItems.state = null;
            }
            // 跳转参数
            if (!Utils.isNoB(self.no)) {
                filterItems.no = self.no;
            }
            if (!Utils.isNoB(self.srcVoucherType)) {
                filterItems.srcVoucherType = self.srcVoucherType;
            }
            if (!Utils.isNoB(self.srcVoucherId)) {
                filterItems.srcVoucherId = self.srcVoucherId;
            }
            if (!Utils.isNoB(self.srcVoucherInnerNo)) {
                filterItems.srcVoucherInnerNo = self.srcVoucherInnerNo;
            }
            //
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            self.exportFilter = Utils.merge({}, filterItems);
            //
            let msgBoxDlg = MsgBox.loading();
            finacApi.getPayVoucherList(postData, function (result) {
                msgBoxDlg.close();
                if (result.type == "info") {
                    let payVoucherList = result.data.rows;
                    self.payVoucherList = Utils.merge([], payVoucherList);
                    //
                    let pagination = result.data.pagination;
                    self.totalCount = pagination.totalCount;
                    self.pageNumber = pagination.pageNumber;
                    self.pageSize = pagination.pageSize;
                    self.renderTable(self.payVoucherList, pagination);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 补充银行卡信息
        editBankAccInfo: function (row) {
            let self = this;
            showBankAccInfoDlg(row, function (bankAccInfo, theDlg) {
                bankAccInfo.id = row.id;
                let hintMsg = bankAccInfo.hintMsg;
                if (!Utils.isNoB(hintMsg)) {
                    self.$confirm(hintMsg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        //
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.updatePayVoucherBankAccInfo(bankAccInfo, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                theDlg.close();
                                self.getPayVoucherList();
                                MsgBox.success("操作成功");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {
                    });
                } else {
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.updatePayVoucherBankAccInfo(bankAccInfo, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            theDlg.close();
                            self.getPayVoucherList();
                            MsgBox.success("操作成功");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            });
        },
        viewPayActRecs: function (voucherId) {
            Vue.$showDialog({
                title: "付款单 - 操作记录",
                showCloseBtn: true,
                cancelText: '关闭',
                okVisible: false,
                width: 900,
                height: 500,
                template: '<div>' +
                    '<swb-pay-act-rec-list :voucherId="voucherId" ref="swb_pay_act-rec_list"></swb-pay-act-rec-list>' +
                    '</div>',
                data: {
                    voucherId: voucherId
                },
                methods: {},
                okClicked: function () {
                },
                lifecycle: {
                    created: function () {
                    }
                }
            })
        },
        //
        paymentOption: function (payVoucher, flag) {
            let payWayInfo = getEnumInfoWith('payWay', 'value', payVoucher.payWay);
            this.showDlg(payVoucher.id, payWayInfo, flag);
        },
        showDlg: function (payVoucherId, payWayInfo, flag) {
            let self = this;
            let title = "";
            let okText = "";
            let okVisible = true;
            let cancelText = '取消';
            if (flag == "fuKuan") {
                title = "付款单 - 付款";
                okText = "确认付款";
            } else if (flag == "chaKan") {
                title = "付款单 - 查看";
                okText = "确定";
                okVisible = false;
                cancelText = '关闭';
            } else {
                title = "付款单 - 审核";
                okText = "确定";
            }
            let theDlg = Vue.$showDialog({
                title: title,
                showCloseBtn: true,
                width: 900,
                height: 800,
                okVisible: okVisible,
                okText: okText,
                cancelText: cancelText,
                template: '<div>' +
                    '<swb-pay-voucher-info :voucherId="voucherId" :optionFlag="optionFlag" ref="swb_pay_voucher_info"></swb-pay-voucher-info>' +
                    '</div>',
                data: {
                    voucherId: null,
                    optionFlag: null
                },
                methods: {
                    // 审核通过
                    auditOption: function (postData) {
                        //
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.auditPayVoucher(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                self.getPayVoucherList();
                            }
                            MsgBox.success(result.message);
                        })
                    },
                    // 确认付款
                    payOption: function (postData) {
                        //
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.updatePayVoucherPayResult(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                self.getPayVoucherList();
                                MsgBox.success("付款成功！");
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    }
                },
                okClicked: function () {
                    let okSelf = this;
                    let result = okSelf.$refs.swb_pay_voucher_info.getDlgResult() || {};
                    // 成功执行
                    if (result.type == 'info') {
                        // 处理你的信息添加赋值
                        let postData = result.data;
                        if (flag == "fuKuan") {
                            let amountPost = parseFloat(postData.amountPost || 0).toFixed(2);
                            if (Utils.isTrue(postData.prePayFlag)) {
                                amountPost = parseFloat(postData.amount || 0).toFixed(2);
                            }
                            self.$confirm('本次需付款金额' + parseFloat(postData.amount).toFixed(2) + '元，实际付款金额' + amountPost + '元，确定要付款吗？', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(function () {
                                // 否则直接走线下支付
                                okSelf.payOption(postData);
                                theDlg.close();
                            }).catch(function () {
                                return false;
                            });
                        } else if (flag == "chaKan") {
                            return true;
                        } else {
                            okSelf.auditOption(postData);
                            return true;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                    return false;
                },
                lifecycle: {
                    created: function () {
                        this.voucherId = payVoucherId;
                        this.optionFlag = flag;
                    }
                }
            })
        },
        // 补录凭证号
        doRecordReservedPayNo: function (row) {
            let self = this;
            openRecordReservedInfoDlg(row.reservedPayNo, row.reservedPayTime, function (reservedInfo) {
                let payVoucher = {
                    id: row.id,
                    reservedPayNo: reservedInfo.reservedPayNo,
                    reservedPayTime: reservedInfo.reservedPayTime
                };
                let msgBoxDlg = MsgBox.loading();
                finacApi.updatePayVoucherReservedInfo(payVoucher, function (result) {
                    msgBoxDlg.close();
                    if (result.type === "info") {
                        MsgBox.success("操作成功！");
                        self.getPayVoucherList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            });
        },
        // 删除操作
        doDelete: function (id) {
            let self = this;
            self.$confirm('确定要删除吗', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let postData = {};
                postData.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.deletePayVoucher(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type === "info") {
                        MsgBox.success("操作成功！");
                        self.getPayVoucherList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }).catch(function () {
            });
        },
        // 跳转到合同列表
        goToContractList: function (tradeType, contractNo) {
            let tradeTypeInfo = getEnumInfoWith('tradeType', 'value', tradeType);
            if (!Utils.isNoB(tradeTypeInfo)) {
                let contractTypeInfo = getEnumInfoWith('contractType', 'tradeType', tradeType);
                if (tradeTypeInfo.name == 'Goods') {
                    if (!Utils.isNoB(contractTypeInfo)) {
                        this.$router.push({
                            path: SwbGoodsPurchContractList.path,
                            query: {
                                no: contractNo
                            }
                        })
                    }
                } else if (tradeTypeInfo.name == 'Servc') {
                    if (!Utils.isNoB(contractTypeInfo)) {
                        this.$router.push({
                            path: SwbServcPurchContractList.path,
                            query: {
                                no: contractNo
                            }
                        })
                    }
                } else if (tradeTypeInfo.name == 'Integ') {
                    if (!Utils.isNoB(contractTypeInfo)) {
                        this.$router.push({
                            path: SwbIntegPurchContractList.path,
                            query: {
                                no: contractNo
                            }
                        })
                    }
                } else {

                }
            }
        },
        // 跳转到订单列表
        goToOrderList: function (orderId, orderNo, orderType) {
            let parentPath = this.$route.path;
            let orderTypeInfo = getEnumInfoWith('orderType', 'value', orderType);
            if (!Utils.isNoB(orderTypeInfo)) {
                if (orderTypeInfo.name == 'GoodsOrder') {
                    this.$router.push({
                        path: SwbShowGoodsOrder.path,
                        query: {
                            goodsOrderId: orderId,
                            parentPath: parentPath
                        }
                    });
                } else {
                    this.$router.push({
                        path: SwbServcOrderOperate.path,
                        query: {
                            id: orderId,
                            parentPath: parentPath
                        }
                    });
                }
            }
        },
        getPostData() {
            let queryModel = this.queryModel;
            let filterItems = Utils.merge({}, this.exportFilter);
            let sortItemList = Utils.merge([], queryModel.sortItemList);
            let sortItems = Utils.merge({}, queryModel.sortItems);
            let multipleSelection = this.getTableSelection();
            if (multipleSelection.length > 0) {
                let ids = [];
                multipleSelection.forEach(function (el) {
                    ids.push(el.id);
                });
                filterItems.ids = ids;
            }
            //
            let postData = {};
            postData.filterItems = filterItems;
            postData.sortItemList = sortItemList;
            postData.sortItems = sortItems;
            //
            return postData;
        },
        // 执行导出任务
        taskExport() {
            if (this.totalCount <= 0) {
                Toast.show('没有需要导出的数据');
                return;
            }
            let self = this;
            let resultTable = this.$refs.result_table;
            let tableData = resultTable.getTableData(true);
            delete tableData.rows;//减少数据传输量
            tableData.data = this.getPostData(null);
            tableData.pageSize = 1000;
            tableData.fileRows = 500000;
            let asynTaskInfo = {};
            asynTaskInfo.ownerId = this.scopeEntity.id;
            asynTaskInfo.ownerType = this.scopeEntity.scopeId;
            asynTaskInfo.bizCode = 'fkd.list.export';
            asynTaskInfo.paramInfo = JSON.encode(tableData);
            // 检查唯一键
            let theLoad = MsgBox.loading();
            comnApi.getAsynTaskInfoByUk(asynTaskInfo, function (result) {
                theLoad.hide();
                if (result.type == 'info') {
                    let data = result.data;
                    if (data == null) {
                        createTaskExportDlg(asynTaskInfo, function () {
                        });
                    } else {
                        self.$confirm('已经创建了相同参数的任务【' + data.title + '】,确定要重新创建吗?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(function () {
                            createTaskExportDlg(asynTaskInfo, function () {
                            });
                        }).catch(function () {

                        });
                    }
                } else {
                    self.$message.warning(result.message);
                }
            });
        },
        viewTaskExport() {
            let params = {};
            params.ownerId = this.scopeEntity.id;
            params.ownerType = this.scopeEntity.scopeId;
            params.bizCode = 'fkd.list.export';
            viewTaskExportListDlg(params);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/payment/PayVoucherList.vue